import {getUser} from '../utils/api'

tag user-page
	def routed params
		user = await getUser params.id
	<self>
		<div.user-view>
			if !user.error
				<h1> "User : {user.id}"
				<ul.meta>
					<li>
						<span.label> "Created: "
						user.created
					<li>
						<span.label> "Karma: "
						user.karma
					if user.about
						<li.about innerHTML=user.about /> " "
				<p.links>
					<a href=`https://news.ycombinator.com/submitted?id={user.id}`> "submissions "
					<a href=`https://news.ycombinator.com/threads?id={user.id}`> "comments"
			else
				<h1> "User not found."